import Base from './pages/base.vue';

const routes = [
    {
        path: '/',
        name: 'base',
        component: Base,
        children: [
            {
                path: '',
                name: 'homepage',
                component: () => import('./pages/homepage/index.vue'),
                meta: {
                    guest: true
                }
            },
            {
                path: 'login',
                name: 'login',
                component: () => import('./pages/auth/login.vue'),
                meta: {
                    guest: true
                }
            },
            {
                path: 'logout',
                name: 'logout',
                component: () => import('./pages/auth/logout.vue'),
            },
            {
                path: 'recover-password',
                name: 'recover password',
                component: () => import('./pages/auth/recover-password.vue'),
                meta: {
                    guest: true
                }
            },
            {
                path: 'reset-password',
                name: 'reset password',
                component: () => import('./pages/auth/reset-password.vue'),
                meta: {
                    guest: true
                }
            },
            {
                path: 'entrance',
                name: 'entrance',
                component: () => import('./pages/auth/entrance.vue'),
                meta: {
                    guest: true
                }
            },
            {
                path: 'dashboard',
                name: 'dashboard',
                component: () => import('./pages/dashboard/index.vue'),
            },
            {
                path: 'calendar/:date?',
                name: 'calendar',
                component: () => import('./pages/calendar/index.vue'),
            },
            {
                path: 'content-library/my-content/:folder?',
                name: 'my content',
                component: () => import('./pages/my-content/index.vue')
            },
            {
                path: 'content-library/:category?/:subcategory?',
                name: 'content library',
                component: () => import('./pages/content/index.vue')
            },
            {
                path: 'content-library/my-content/draft-posts',
                name: 'drafts',
                component: () => import('./pages/my-content/draft-posts.vue')
            },
            {
                path: 'business_center',
                name: 'business center',
                component: () => import('./pages/business_center/index.vue')
            },
            {
                path: 'connections',
                name: 'connections',
                component: () => import('./pages/connections/index.vue')
            },
            {
                path: 'post_maker',
                name: 'post maker',
                component: () => import('./pages/post_maker/index.vue')
            },

            {
                path: 'analytics',
                name: 'analytics',
                component: () => import('./pages/analytics/user/index.vue')
            },
            {
                path: 'training',
                name: 'training',
                component: () => import('./pages/training/base.vue'),
                children: [
                    {
                        path: '',
                        name: 'training home',
                        component: () => import('./pages/training/index.vue')
                    },
                    {
                        path: 'old',
                        name: 'training old home',
                        component: () => import('./pages/training/index_old.vue')
                    },
                    {
                        path: 'collections',
                        name: 'training collections',
                        component: () => import('./pages/training/collections.vue')
                    },
                    {
                        path: 'collections/:slug',
                        name: 'training collection lessons',
                        component: () => import('./pages/training/collection.vue')
                    },
                    {
                        path: 'collections/:collection_slug/:lesson_slug',
                        name: 'training collection lesson',
                        component: () => import('./pages/training/lesson.vue')
                    },
                    {
                        path: 'lessons',
                        name: 'training lessons',
                        component: () => import('./pages/training/lessons.vue')
                    },
                    {
                        path: 'lessons/:lesson_slug',
                        name: 'training lesson',
                        component: () => import('./pages/training/lesson.vue')
                    },
                    {
                        path: 'quickfixes',
                        name: 'training quickfixes',
                        component: () => import('./pages/training/quickfixes.vue')
                    },
                ],
            },
            {
                path: 'settings',
                name: 'settings',
                component: () => import('./pages/settings/index.vue')
            },
        ]
    },
    { path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('./pages/errors/not-found.vue'),
        meta: {
            error: true
        },
    },
];

export default routes
